// Monotone cubic Hermite interpolation, independently limited per segment.
// Each curve stays within its actual endpoints. Missing points break the path.
export function monotoneSegments(points){
 const runs=[];let run=[];
 for(const p of points){if(p.y==null || !Number.isFinite(p.y)){if(run.length)runs.push(run);run=[];}else run.push(p);}
 if(run.length)runs.push(run);
 return runs.map(r=>{
  if(r.length<2)return {points:r,curves:[]};
  const slopes=r.slice(1).map((p,i)=>(p.y-r[i].y)/(p.x-r[i].x));
  const tangents=r.map((p,i)=>i===0?slopes[0]:i===r.length-1?slopes.at(-1):slopes[i-1]*slopes[i]<=0?0:2/(1/slopes[i-1]+1/slopes[i]));
  const curves=slopes.map((s,i)=>{
   let a=tangents[i],b=tangents[i+1];
   if(s===0){a=0;b=0;}else{const radius=Math.hypot(a/s,b/s);if(radius>3){a*=3/radius;b*=3/radius;}}
   const dx=(r[i+1].x-r[i].x)/3;
   return {from:r[i],to:r[i+1],c1:{x:r[i].x+dx,y:r[i].y+a*dx},c2:{x:r[i+1].x-dx,y:r[i+1].y-b*dx}};
  });return {points:r,curves};
 });
}
export function smoothPaths(points){return monotoneSegments(points).map(run=>`M${run.points[0].x},${run.points[0].y}`+run.curves.map(c=>` C${c.c1.x},${c.c1.y} ${c.c2.x},${c.c2.y} ${c.to.x},${c.to.y}`).join(''));}

// Close each real contiguous curve to zero independently; gaps never gain fill.
export function smoothAreas(points,zero){return monotoneSegments(points).filter(run=>run.points.length>1).map(run=>{const line=`M${run.points[0].x},${run.points[0].y}`+run.curves.map(c=>` C${c.c1.x},${c.c1.y} ${c.c2.x},${c.c2.y} ${c.to.x},${c.to.y}`).join('');return `${line} L${run.points.at(-1).x},${zero} L${run.points[0].x},${zero} Z`;});}
